import Vue from 'vue';
import axios from 'axios';
import L, { control as lControl } from "leaflet";
import localDataFunctions from '@/localDataFunctions';
import { type } from 'devexpress-dashboard/data/_utils';

export default {
  name: 'Mapcomp',
  mixins: [localDataFunctions],
  components: {
    CustomFieldsComp: require('../customFields.vue').default,
    Slider: require('@/customcontrols/slider.vue').default,
  },
  props: {
    dataObj: {
      type: Object,
      default: {}
    },
    enableLRS: {
      type: Boolean,
      default: false
    },
    parentComp: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      mapOffset: 500,
      hasPolylines: false,
      //lineWidthOptions: [8, 10, 15, 20, 25, 30, 40],
      //loadElementsAroundCenterDistances: [
      //  { text: '100m', val: 0.001 },
      //  { text: '200m', val: 0.002 },
      //  { text: '500m', val: 0.005 },
      //  { text: '1km', val: 0.01 },
      //  { text: '2km', val: 0.02 },
      //  { text: '5km', val: 0.05 },
      //  { text: '10km', val: 0.1 },
      //  { text: 'all', val: 0 }
      //],
      gisSettings: {},
      
      mapSettings: {
        map: null,
        zoom: 15,
        polylineColor: 'orange',
        systemPolylineColor: 'green',
        center: [],
        mapCenter: { lng: 0, lat: 0 },
        offset: 0.005, // 0.001 = 111 meters
        offsetChanged: false,
        allElementsLoaded: false,
        isRendering: false,
        polyline: {
          weight: null,
          fill: true,
          fillColor: '#03e8fc',
          fillOpacity: 0.1,
        },
      },

      layers: [],
      markers: [],
      selectedType: {},
      addMapClickEvents: false,
      addMapDoubleEvents: false,
      addMapMouseOverEvents: false,
      addMapDragEndEvents: false,

      allPolylines: [],
      polylines: [],
      allSystemPolylines: [],
      systemPolylines: [],

      lrsFirstIcon: {},
      lrsSecondIcon: {},
      lrsDefaultIcon: {},
      lrsFirstIconUrl: 'http://maps.google.com/mapfiles/kml/paddle/blu-circle.png',
      lrsSecondIconUrl: 'http://maps.google.com/mapfiles/kml/paddle/orange-circle.png',

      customFields: [],
      customFieldsGroups: [],

      currentTab: 'tab-map',

      captureElementMarkersCnt: 0,
      elementsLayers: [],
      deviceIsMobile: false,
      currentMobileLocation: []
    };
  },
  mounted() {
    //console.log('mounted');
    //this.initMap();
    //this.getElementsByLngLatType();
  },
  created() {
    let temp = this.getFromLocal('_map_load_around_center');
    this.mapOffset = !temp ? 500 : temp;
    this.mapSettings.polyline.weight = this.getFromLocal('_map_polyline_weight') ?? 6;
    this.getUserLocation();

    setTimeout(() => {
      this.isMobile();
      //console.log('map.ts', this.dataObj);
      this.getGisSettings();

      if (this.enableLRS) {
        this.selectedType = this.dataObj.availableLrsEventTypes[this.dataObj.elementTypeId][0];
      }

      if (this.dataObj.latitude && this.dataObj.longitude && this.dataObj.latitude !== 0 && this.dataObj.longitude !== 0 && this.dataObj.elementTypeId === -1 && this.dataObj.elementId === -1) {
        this.getElementsByLngLat();
      }
      if (this.dataObj.elementTypeId && this.dataObj.elementId && this.dataObj.elementTypeId > -1 && this.dataObj.elementId > -1) {
        this.zoomToElement();
      }
      if (this.dataObj.elementTypeId && this.dataObj.elementId && this.dataObj.elementTypeId > -1 && this.dataObj.elementId === -1) {
        //this.getElementsByLngLatType();
        this.getElementsByArea();
      }

      this.lrsFirstIcon = L.icon({
        iconUrl: this.lrsFirstIconUrl,
        iconSize: [64, 64]
      });

      this.lrsSecondIcon = L.icon({
        iconUrl: this.lrsSecondIconUrl,
        iconSize: [64, 64]
      });

      this.lrsDefaultIcon = L.icon({
        iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      if (this.dataObj.captureMissingJobcardElement)
        this.getCustomFields();
    }, 2000);
  },
  computed: {
    polylinesInBounds() {
      if (!this.map) return [];

      const bounds = this.map.getBounds();

      return this.polylines.filter((polyline) => {
        for (let i = 0; i < polyline.path.length; i++) {
          const latLng = L.latLng(polyline.path[i]);
          if (bounds.contains(latLng)) {
            return true;
          }
        }

        return false;
      });
    },
    polylinesLength() {
      return !this.polylines ? 0 : this.polylines.length;
    },
  },
  watch: {
    polylinesLength: function (val) {
      if (val && val > 0)
        this.hasPolylines = true;
    }
  },
  methods: {
    getGisSettings() {
      axios.post('/gis/GetGisSettings')
        .then(response => {
          this.gisSettings = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadMarkers() {
      for (var i = 0; i < this.markers.length; i++) {
        const marker = L.marker(this.markers[i].position,
          {
            draggable: this.markers[i].draggable == undefined ? false : this.markers[i].draggable,
            icon: this.markers[i].icon == undefined ? this.lrsDefaultIcon : this.markers[i].icon,
          }
        ).addTo(this.mapSettings.map);

        marker['data'] = this.markers[i].data;

        marker.on('dragend', (e) => {
          if (e.target.options.icon.options.iconUrl == this.lrsFirstIconUrl) {
            this.markers[1].position.lat = e.target.getLatLng().lat;
            this.markers[1].position.lng = e.target.getLatLng().lng;
          }

          if (e.target.options.icon.options.iconUrl == this.lrsSecondIconUrl) {
            this.markers[2].position.lat = e.target.getLatLng().lat;
            this.markers[2].position.lng = e.target.getLatLng().lng;
          }
        });


        if (this.addMapDoubleEvents) {
          marker.on('dblclick', (event) => {
            //console.log(event.target);
            var strID = event.target.data.properties.ID;
            var strNAME = event.target.data.properties.NAME;
            var isSelected = event.target.data.properties.isSelected;
            isSelected = !isSelected;
            event.target.data.properties.isSelected = isSelected;

            const geoType = event.target.data.geometry.type.toLowerCase();

            if (geoType === 'point') {
              var elLOCATION = 'lat: ' + event.target.data.geometry.coordinates[1] + ', lng: ' + event.target.data.geometry.coordinates[0];
              localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION + ', Selected');
            }

            if (geoType === 'multilinestring') {
              var elLOCATION = '';
              for (var i = 0; i < event.target.data.geometry.coordinates.length; i++) {
                elLOCATION += 'lat: ' + event.target.data.geometry.coordinates[i][1] + ', lng: ' + event.target.data.geometry.coordinates[i][0] + '\n';
              }

              localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION + ', Selected');
            }

            this.getMapX();
          });
        }
      }
    },
    initMap() {
      //console.log(this.mapSettings);
      //console.log(this.dataObj);
      //console.log(this.$refs.map);
      //console.log({ ...this.gisSettings });

      if (this.mapSettings.map !== null) {
        this.loadPolylines();
        this.loadMarkers();
       
        return;
      }

      if (this.mapSettings.center.length > 0 && (this.dataObj.captureMissingJobcardElement || this.dataObj.captureOtherMissingElement || this.dataObj.captureFieldElements))
        this.mapSettings.map = L.map(this.$refs.map).setView(this.mapSettings.center, this.mapSettings.zoom).on("click", this.addMarker);
      else
        this.mapSettings.map = L.map(this.$refs.map).setView(this.mapSettings.center, this.mapSettings.zoom);

      //this.mapSettings.map.on('dragend', this.onMapMove);
      //this.mapSettings.map.on('zoomend', this.onMapMove);

      //add all layers to map - overlayes not implemented
      let overlayMaps = {}, baseMaps = {};

      //default choice
      if (this.gisSettings.useGoogleMapsDefaultView) {
        let googleEarth = L.tileLayer('https://{s}.google.com/vt?lyrs=s,h&x={x}&y={y}&z={z}',
          {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          }
        );

        let google = L.tileLayer('http://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}',
          {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          }
        );

        googleEarth.addTo(this.mapSettings.map);

        baseMaps["Google Map"] = google;
        baseMaps["Google Earth"] = googleEarth;
      }

      let osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }
      );

      if (!this.gisSettings.useGoogleMapsDefaultView)
        osm.addTo(this.mapSettings.map);

      baseMaps["OpenStreetMap"] = osm;
      
        

      //remove leaflet attribution
      this.mapSettings.map.attributionControl.setPrefix('');



      (lControl.layers(baseMaps, overlayMaps) as any)
        .addTo(this.mapSettings.map);

      var mrks = [];
      for (var i = 0; i < this.markers.length; i++) {
        var arr = [{
          lat: this.markers[i].position.lat,
          lng: this.markers[i].position.lng
        }];
        mrks.push([
          arr
        ]);
      }

      if (!this.dataObj.captureMissingJobcardElement && !this.dataObj.captureOtherMissingElement && !this.dataObj.captureFieldElements) {
        this.loadMarkers();
      } else {
        const ico = L.icon({
          iconUrl: 'http://maps.google.com/mapfiles/kml/pal4/icon49.png',
          iconAnchor: [12, 41],
          popupAnchor: [12, -41]
        });

        for (var i = 0; i < this.markers.filter(a => !a.isCenter).length; i++) {
          L.marker(this.markers[i].position,
            {
              draggable: false,
              icon: ico,
            }
          ).addTo(this.mapSettings.map);
        }
      }

      this.mapSettings.map.on('moveend', this.loadOnMove);
      this.loadPolylines();
    },
    onOffsetChanged() {
      if (this.mapSettings.offset === 0 && this.mapSettings.allElementsLoaded === false) {
        this.mapSettings.allElementsLoaded = true;
        this.getElementsByLngLatType();
      } else {
        this.mapSettings.allElementsLoaded = false;
        this.loadOnMove();
      }
    },
    onMapMove() {
      const center = this.mapSettings.map.getCenter();
      console.log("center", center)
      this.mapSettings.mapCenter.lat = center.lat;
      this.mapSettings.mapCenter.lng = center.lng;

      if (this.dataObj.elementTypeId && this.dataObj.elementId && this.dataObj.elementTypeId > -1 && this.dataObj.elementId === -1) {
        //this.getElementsByLngLatType();
        this.getElementsByArea();
      }
    },
    getElementsByLngLatType() {
      var sUrl = '/Element/GetElementsByLngLat?longitude=' + this.dataObj.longitude + '&latitude=' + this.dataObj.latitude + '&elementTypeId=' + this.dataObj.elementTypeId.toString();
      this.$store.state.notifier.asyncBlock(
        axios.get(sUrl),
        response => {
          if (response.status == 200) {
            this.layers = response.data.layers;

            //console.log(this.layers);

            this.addMapDoubleEvents = true;
            this.addMapMouseOverEvents = true;
            this.addMapDragEndEvents = true;
            this.fillMapData(response.data.layers);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Caching Map Elements'
      );
    },
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.mapSettings.mapCenter.lat = position.coords.latitude;
            this.mapSettings.mapCenter.lng = position.coords.longitude;
          },
          error => {
            console.error("Error getting location: " + error.message);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    getElementsByArea() {
      //console.log(this.mapSettings);
      this.mapSettings.isRendering = false;

      const northwest = { lat: this.mapSettings.mapCenter.lat + this.mapSettings.offset, lng: this.mapSettings.mapCenter.lng - this.mapSettings.offset };
      const northeast = { lat: this.mapSettings.mapCenter.lat + this.mapSettings.offset, lng: this.mapSettings.mapCenter.lng + this.mapSettings.offset };
      const southeast = { lat: this.mapSettings.mapCenter.lat - this.mapSettings.offset, lng: this.mapSettings.mapCenter.lng + this.mapSettings.offset };
      const southweast = { lat: this.mapSettings.mapCenter.lat - this.mapSettings.offset, lng: this.mapSettings.mapCenter.lng - this.mapSettings.offset };

      const params = {
        area: [
          { lon: northwest.lng, lat: northwest.lat },
          { lon: northeast.lng, lat: northeast.lat },
          { lon: southeast.lng, lat: southeast.lat },
          { lon: southweast.lng, lat: southweast.lat },
          { lon: northwest.lng, lat: northwest.lat }
        ],
        elementTypeIds: [this.dataObj.elementTypeId],
        elementLimitPerLayer: 0
      };

      var sUrl = '/Element/GetElementsByArea';

      this.$store.state.notifier.asyncBlock(
        axios.post(sUrl, params),
        response => {
          if (response.status == 200) {
            //console.log(response.data);


            this.layers = response.data.layers;

            this.addMapDoubleEvents = true;
            this.addMapMouseOverEvents = true;
            this.addMapDragEndEvents = true;

            if (this.mapSettings.center.length === 0) {
              this.mapSettings.center.push(this.mapSettings.mapCenter.lat);
              this.mapSettings.center.push(this.mapSettings.mapCenter.lng);
            }

            this.fillShaps(response.data.layers);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Caching Map Elements'
      );
    },
    getElementsByLngLat() {
      var sUrl = '/Element/GetElementsByLngLat?longitude=' + this.dataObj.longitude + '&latitude=' + this.dataObj.latitude;
      this.$store.state.notifier.asyncBlock(
        axios.get(sUrl),
        response => {
          if (response.status == 200) {
            this.layers = response.data.layers;
            this.addMapClickEvents = true;
            this.addMapDoubleEvents = true;
            this.addMapMouseOverEvents = true;
            this.addMapDragEndEvents = true;
            this.fillMapData(response.data.layers);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Caching Map Elements'
      );
    },
    zoomToElement() {
      var sUrl = '/Element/GetElementsByLngLat?longitude=' + this.dataObj.longitude + '&latitude=' + this.dataObj.latitude + '&elementTypeId=' + this.dataObj.elementTypeId.toString();
      this.$store.state.notifier.asyncBlock(
        axios.get(sUrl),
        response => {
          if (response.status == 200) {
            this.layers = response.data.layers;
            this.markers = [];

            if (this.layers.length > 0) {
              var layerType = this.layers[0].geoJson.features[0].geometry.type;
              if (layerType === 'Point') {
                var coords = this.layers[0].geoJson.features[0].geometry.coordinates;
                this.mapSettings.center.lng = coords[0];
                this.mapSettings.center.lat = coords[1];
              }
              else if (layerType === 'MultiPolygon') {
                var coords = this.layers[0].geoJson.features[0].geometry.coordinates[0][0];
                this.mapSettings.center.lng = coords[0][0];
                this.mapSettings.center.lat = coords[0][1];
              }
              else {
                var coords = this.layers[0].geoJson.features[0].geometry.coordinates[0][0];
                this.mapSettings.center.lng = coords[0];
                this.mapSettings.center.lat = coords[1];
              }
            }

            this.$store.state.notifier.asyncBlock(
              axios.get('/Element/GetElementsByLngLat?elementTypeId=' + this.dataObj.elementTypeId + '&elementId=' + this.dataObj.elementId),
              response => {
                if (response.status == 200) {
                  this.layers = response.data.layers;
                  this.fillMapData(response.data.layers);
                }
              },
              err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
                this.$alertMsg(err.data.data.text),
              'Caching Map Elements'
            );
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Caching Map Elements'
      );
    },
    fillMapData(layers) {
      if (!layers || layers.length == 0 || !layers[0].geoJson || !layers[0].geoJson.features || layers[0].geoJson.features.length === 0) {
        this.$alertMsg(this.$t('common.noElements'));
        return;
      }

      this.fillCenter(layers);
      this.fillShaps(layers);
    },
    fillCenter(layers) {
      if (this.deviceIsMobile && this.currentMobileLocation.length > 0) {
        this.mapSettings.center = [];

        this.mapSettings.center.push(this.currentMobileLocation[0]);
        this.mapSettings.center.push(this.currentMobileLocation[1]);

        return;
      }

      if (layers.length > 0) {
        var layerType = layers[0].geoJson.features[0].geometry.type;
        if (layerType === 'Point') {
          var coords = layers[0].geoJson.features[0].geometry.coordinates;
          this.mapSettings.center.push(coords[1]);
          this.mapSettings.center.push(coords[0]);
        }
        else if (layerType === 'MultiPolygon') {
          var coords = layers[0].geoJson.features[0].geometry.coordinates[0][0];
          this.mapSettings.center.push(coords[0][1]);
          this.mapSettings.center.push(coords[0][0]);
        }
        else {
          var coords = layers[0].geoJson.features[0].geometry.coordinates[0][0];
          this.mapSettings.center.push(coords[1]);
          this.mapSettings.center.push(coords[0]);
        }
      }
    },
    fillShaps(layers) {
      if (layers.length > 0) {
        this.allPolylines = [];

        for (var i = 0; i < layers[0].geoJson.features.length; i++) {
          //if (i == 0) {
          //  this.fillCenter(layers);
          //}

          if (layers[0].geoJson.features[i].geometry.coordinates[0].length > 1) {
            var plyCord = [];
            var subPlyCord = [];
            for (var c = 0; c < layers[0].geoJson.features[i].geometry.coordinates.length; c++) {
              for (var w = 0; w < layers[0].geoJson.features[i].geometry.coordinates[c].length; w++) {
                subPlyCord = [];
                subPlyCord.push(
                  layers[0].geoJson.features[i].geometry.coordinates[c][w][1],
                );
                subPlyCord.push(
                  layers[0].geoJson.features[i].geometry.coordinates[c][w][0],
                );

                plyCord.push(subPlyCord);
              }
            }

            this.allPolylines.push({
              name: layers[0].geoJson.features[i].properties.NAME,
              //id: layers[0].geoJson.features[i].properties.ID,
              //elementTypeId: layers[0].geoJson.features[i].properties.elementTypeId,
              path: plyCord,
              data: layers[0].geoJson.features[i]
            });
          }
          else {
            if (layers[0].geoJson.features[i].geometry.coordinates[0].length === 0)
              continue;

            this.markers.push({
              position: {
                lat: layers[0].geoJson.features[i].geometry.coordinates[1],
                lng: layers[0].geoJson.features[i].geometry.coordinates[0],
              },
              data: layers[0].geoJson.features[i]
            });
          }
        }

        if (this.markers.length == 0) {
          this.markers.push({
            position: {
              lat: this.mapSettings.center[0],
              lng: this.mapSettings.center[1],
            },
          });
        }

        if (this.enableLRS) {
          if (this.dataObj.eventTypeId > 0 && this.dataObj.eventId > 0) {
            this.get();
          } else {
            this.markers = [];
            this.markers.push({ position: { lat: this.mapSettings.center[0], lng: this.mapSettings.center[1] } });
            this.markers.push({ position: { lat: this.mapSettings.center[0], lng: this.mapSettings.center[1] }, draggable: true, icon: this.lrsFirstIcon });

            if (!this.selectedType.isPointEvent)
              this.markers.push({ position: { lat: this.mapSettings.center[0], lng: this.mapSettings.center[1] }, draggable: true, icon: this.lrsSecondIcon });

            //this.setupLeafletMap();
            this.initMap();
          }
        } else {
          //this.setupLeafletMap();
          this.initMap();
        }
      } else {
        this.initMap();
      }
    },
    loadOnMove() {
      if (this.dataObj.elementTypeId && this.dataObj.elementId && this.dataObj.elementTypeId > -1 && this.dataObj.elementId === -1) {
        const dist = this.calculateDistance();

        if (this.mapSettings.offset === 0) {
          this.mapSettings.isRendering = false;
          this.loadPolylines();
        } else {
          if (!this.mapSettings.map)
            return;

          const center = this.mapSettings.map.getCenter();
          this.mapSettings.mapCenter.lat = center.lat;
          this.mapSettings.mapCenter.lng = center.lng;

          if (dist > 0.05 || this.mapSettings.offsetChanged === true) {
            this.mapSettings.offsetChanged = false;
            this.getElementsByArea();
          } else {
            this.mapSettings.offsetChanged = false;
            return;
          }
        }
      } else {
      this.mapSettings.isRendering = false;
      this.loadPolylines();
      }
    },
    calculateDistance() {
      if (!this.mapSettings.map)
        return;

      const center = this.mapSettings.map.getCenter();

      const R = 6371;
      const lat1 = this.degreesToRadians(center.lat);
      const lon1 = this.degreesToRadians(center.lng);
      const lat2 = this.degreesToRadians(this.mapSettings.mapCenter.lat);
      const lon2 = this.degreesToRadians(this.mapSettings.mapCenter.lng);

      const dLat = lat2 - lat1;
      const dLon = lon2 - lon1;

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const distance = R * c;

      //return this.roundAbsNumber(distance);
      return Math.abs(distance).toFixed(2);
    },
    roundAbsNumber(number) {
      if (number == null || number == '')
        return 0;
      
      let num;

      if (typeof number == 'string')
        num = parseFloat(number);

      return Math.abs(num).toFixed(2);
    },
    degreesToRadians(degrees) {
      return degrees * (Math.PI / 180);
    },
    async loadPolylines() {
      if (this.mapSettings.isRendering)
        return;

      this.mapSettings.isRendering = true;
      const bounds = this.mapSettings.map.getBounds();

      this.polylines = this.filterPolylinesByBounds(this.allPolylines, bounds);

      this.clearPolylines();

      while (this.mapSettings.isRendering) {
        for (let i = 0; i < this.polylines.length; i++) {
          let item = this.polylines[i];

          await this.sleep(1);
          const polyline = L.polyline(item.path,
            {
              color: this.mapSettings.polylineColor,
              ...this.mapSettings.polyline
              
            }).addTo(this.mapSettings.map).bindTooltip(item.name);

          polyline['data'] = item.data;

          if (this.addMapDoubleEvents) {
            polyline.on('dblclick', (event) => {
              var strID = event.target.data.properties.ID;
              var strNAME = event.target.data.properties.NAME;
              var isSelected = event.target.data.properties.isSelected;
              isSelected = !isSelected;
              event.target.data.properties.isSelected = isSelected;

              const geoType = event.target.data.geometry.type.toLowerCase();

              if (geoType === 'point') {
                var elLOCATION = 'lat: ' + event.target.data.geometry.coordinates[1] + ', lng: ' + event.target.data.geometry.coordinates[0];
                localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION + ', Selected');
              }

              if (geoType === 'multilinestring') {
                var elLOCATION = '';
                for (var i = 0; i < event.target.data.geometry.coordinates.length; i++) {
                  elLOCATION += 'lat: ' + event.target.data.geometry.coordinates[i][1] + ', lng: ' + event.target.data.geometry.coordinates[i][0] + '\n';
                }

                localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION + ', Selected');
              }

              this.getMapX();
            });
          }
        }

        if (this.dataObj.captureMissingJobcardElement || this.dataObj.captureOtherMissingElement || this.dataObj.captureFieldElements) {
          this.markers[0].isCenter = true;
        }

        if ((this.dataObj.captureMissingJobcardElement || this.dataObj.captureOtherMissingElement || this.dataObj.captureFieldElements) && this.dataObj.systemElementType)
          this.systemElementPipes();

        if (this.dataObj.captureOtherMissingElement)
          this.drawCapturedElements();

        if (this.dataObj.captureFieldElements)
          this.drawFieldCapturedElements();

        this.mapSettings.isRendering = false;
      }
    },
    filterPolylinesByBounds(polylines, bounds) {
      return polylines.filter(polyline => {
        const polylineBounds = L.latLngBounds(polyline.path);
        return bounds.intersects(polylineBounds);
      });
    },
    sleep(tm: number): Promise<void> {
      return new Promise<void>((resolve) => {
        setTimeout(resolve, tm)
      })
    },
    clearPolylines() {
      this.mapSettings.map.eachLayer(layer => {
        if (layer instanceof L.Polyline) {
          this.mapSettings.map.removeLayer(layer);
          //if (this.polylines.some(p => p.data.properties.ID === layer['data'].properties.ID)) {
          //  console.log('exist');
          //  const idx = this.polylines.indexOf(a => a.data.properties.ID === layer['data'].properties.ID);
          //  this.polylines.splice(idx, 1);
          //}
          //else {
          //  this.mapSettings.map.removeLayer(layer);
          //}
        }
      });
    },
    getCustomFields() {
      axios.get('/Element/GetCustomFields?elementTypeId=' + (this.dataObj.linkedFieldTypeId > 0 ? this.dataObj.linkedFieldTypeId : this.dataObj.elementTypeId))
        .then(resp => {
          this.customFields = resp.data;

          this.customFieldsGroups = [];

          for (var i = 0; i < this.customFields.length; i++) {
            if (this.customFieldsGroups.filter(a => a == this.customFields[i].groupName).length == 0)
              this.customFieldsGroups.push(this.customFields[i].groupName);
          }
        })
        .catch(err => {
          this.$alertMsg(err.message);
        });
    },
    get() {
      axios.get('/LrsEvent/Get?typeId=' + this.dataObj.eventTypeId + '&eventId=' + this.dataObj.eventId)
        .then(response => {
          this.markers = [];
          this.markers.push({ position: { lat: this.mapSettings.center[0], lng: this.mapSettings.center[1] } });

          this.markers.push({ position: { lat: response.data.points[0].y, lng: response.data.points[0].x }, draggable: true, icon: this.lrsFirstIcon });

          if (!this.selectedType.isPointEvent)
            this.markers.push({ position: { lat: response.data.points[1].y, lng: response.data.points[1].x }, draggable: true, icon: this.lrsSecondIcon });

          //this.setupLeafletMap();
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    createOrUpdate() {
      let points = [];

      for (var i = 1; i < this.markers.length; i++) {
        points.push({
          X: this.markers[i].position.lng,
          Y: this.markers[i].position.lat
        });
      }

      const params = {
        typeId: this.selectedType.id,
        eventId: this.dataObj.eventId == -1 ? 0 : this.dataObj.eventId,
        eventName: this.dataObj.jobcardId,
        elementId: this.dataObj.elementId,
        sourceId: this.dataObj.jobcardId,
        sourceType: 1,
        connectivityType: 0,
        points: points,
        StartDate: new Date(),
        EndDate: new Date()
      };

      axios.post('/LrsEvent/CreateOrUpdate', params)
        .then(response => {
          this.dataObj.eventTypeId = response.data.typeId;
          this.dataObj.eventId = response.data.eventId;

          this.setLrsEvent(response.data.typeId, response.data.eventId);
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    setLrsEvent(typeId, eventId) {
      const params = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: this.dataObj.appKey,
        LrsEventTypeId: typeId,
        LrsEventId: eventId
      };

      axios.post('/OmJobcardActivity/SetLrsEvent', params)
        .then(response => {
          this.$alertMsg(this.$t('lrs.savedSuccessfully')), 2;
          this.parentComp.refillLrsData(typeId, eventId);
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    getMapX() {
      var msg = localStorage.getItem("map-x");
      localStorage.removeItem('map-x');

      if (msg) {
        this.$alertMsg(this.$t('common.elementSelected'), 1);
        var msgArray = msg.split(',');
        var sIdStr = msgArray[0];
        var sIdArray = sIdStr.split('=');
        this.dataObj.elementId = parseInt(sIdArray[1]);
        this.$root.$emit('element_selected');
        return;
      }
    },
    changeTab(e) {
      this.currentTab = e;
    },
    getGroupFields(grp) {
      const fields = {
        items: this.customFields.filter(a => a.groupName == grp)
      };
      return fields;
    },
    systemElementPipes() {
      axios.get('/Element/GetElementsByLngLat?longitude=' + this.dataObj.longitude + '&latitude=' + this.dataObj.latitude + '&elementTypeId=' + this.dataObj.systemElementType.typeId.toString())
        .then(response => {
          if (response.status == 200) {
            this.allSystemPolylines = [];

            const layers = response.data.layers[0].geoJson.features;
            var polyline = null;

            for (var i = 0; i < layers.length; i++) {
              var plyCord = [];
              var subPlyCord = [];
              for (var c = 0; c < layers[i].geometry.coordinates.length; c++) {
                for (var w = 0; w < layers[i].geometry.coordinates[c].length; w++) {
                  subPlyCord = [];
                  subPlyCord.push(
                    layers[i].geometry.coordinates[c][w][1],
                  );
                  subPlyCord.push(
                    layers[i].geometry.coordinates[c][w][0],
                  );

                  plyCord.push(subPlyCord);
                }
              }

              this.allSystemPolylines.push({
                name: layers[0].geoJson.features[i].properties.NAME,
                //id: layers[0].geoJson.features[i].properties.ID,
                //elementTypeId: layers[0].geoJson.features[i].properties.elementTypeId,
                path: plyCord,
                data: layers[0].geoJson.features[i]
              });

              this.loadSystemPolylines();              
            }
          }
        })
        .catch(error => {

        });
    },
    drawCapturedElements() {
      for (var el = 0; el < this.parentComp.captureElements.elements.length; el++) {
        const mrks = this.parentComp.captureElements.elements[el].markers;

        if (mrks.length == 0)
          continue;

        var plyCord = [];
        for (var i = 0; i < mrks.length; i++) {
          var subPlyCord = [];
          subPlyCord.push(mrks[i].position.lat);
          subPlyCord.push(mrks[i].position.lng);

          plyCord.push(subPlyCord);
        }

        if (this.parentComp.captureElements.elements[el].elementType.geometryType == 1) {
          L.polyline(plyCord, {
            ...this.mapSettings.polyline,
            color: this.dataObj.colorArray[el],
          }).addTo(this.mapSettings.map);
        } else if (this.parentComp.captureElements.elements[el].elementType.geometryType == 2) {
          L.polygon(plyCord, {
            weight: 3,
            color: this.dataObj.colorArray[el],
          }).addTo(this.mapSettings.map);
        }
      }
    },
    drawFieldCapturedElements() {
      for (var el = 0; el < this.parentComp.capturedElements.length; el++) {
        const mrks = this.parentComp.capturedElements[el].markers;

        if (mrks.length == 0)
          continue;

        var plyCord = [];
        for (var i = 0; i < mrks.length; i++) {
          var subPlyCord = [];
          subPlyCord.push(mrks[i].position.lat);
          subPlyCord.push(mrks[i].position.lng);

          plyCord.push(subPlyCord);
        }

        if (this.parentComp.capturedElements[el].elementType.geometryType == 1) {
          L.polyline(plyCord, {
            ...this.mapSettings.polyline,
            color: this.dataObj.colorArray[el],
          }).addTo(this.mapSettings.map);
        } else if (this.parentComp.capturedElements[el].elementType.geometryType == 2) {
          L.polygon(plyCord, {
            weight: 3,
            color: this.dataObj.colorArray[el],
          }).addTo(this.mapSettings.map);
        }
      }
    },
    addCurrentElementMarker(pos) {
      if (this.dataObj.captureOtherMissingElement)
        if (this.markers.filter(a => !a.isCenter && a.marker).length == 1 && this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 0)
          return;

      if (this.dataObj.captureFieldElements)
        if (this.markers.filter(a => !a.isCenter && a.marker).length == 1 && this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].elementType.geometryType == 0)
          return;

      this.captureElementMarkersCnt++;

      const buttonRemove =
        `<button type="button" class="remove">${this.$t('common.removeMarker')}</button>`;

      const position = {
        lat: pos.lat,
        lng: pos.lng
      };

      const marker = L.marker(position,
        {
          draggable: true,
          icon: L.icon({
            iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
            iconAnchor: [12, 41],
            popupAnchor: [12, -41]
          }), alt: this.dataObj.captureOtherMissingElement ? `marker__${this.parentComp.captureElements.selectedElementIdx.toString()}__${this.captureElementMarkersCnt.toString()}`
            : this.dataObj.captureFieldElements ? `marker__${this.parentComp.selectedCapturedElementIdx.toString()}__${this.captureElementMarkersCnt.toString()}`
              : ''
        }
      ).addTo(this.mapSettings.map)
        .bindPopup(buttonRemove);

      marker.on('dragend', (event) => {
        this.markerIdx = this.markers.indexOf(this.markers.filter(a => !a.isCenter).filter(a => a.marker.options.alt == event.target.options.alt)[0]);

        this.markers[this.markerIdx].position.lat = event.target._latlng.lat;
        this.markers[this.markerIdx].position.lng = event.target._latlng.lng;

        if (this.dataObj.captureOtherMissingElement)
          if (this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 1 || this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 2) {
            this.drawElementLayer();
          }

        if (this.dataObj.captureFieldElements)
          if (this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].elementType.geometryType == 1 || this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].elementType.geometryType == 2)
            this.drawElementLayer();
      });

      this.markers.push({ position, marker });

      marker.on("popupopen", this.removeMarkerPopupHandler);

      if (this.dataObj.captureOtherMissingElement)
        if (this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 1 || this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 2)
          this.drawElementLayer();

      if (this.dataObj.captureFieldElements)
        if (this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].elementType.geometryType == 1 || this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].elementType.geometryType == 2)
          this.drawElementLayer();
    },
    addCurrentElementMarker2(marers) {
      this.markers = [];

      for (var l in this.mapSettings.map._layers) {
        if (this.mapSettings.map._layers[l].options?.alt?.includes('marker__')) {
          this.mapSettings.map.removeLayer(this.mapSettings.map._layers[l]);
        }
      }

      this.captureElementMarkersCnt = -1;

      for (var i = 0; i < marers.length; i++) {
        this.addCurrentElementMarker(marers[i].position);
      }
    },
    saveMarkersIntoParent(markers) {
      if (this.dataObj.captureOtherMissingElement) {

      }

      if (this.dataObj.captureFieldElements) {
        this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].markers = [];
        this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].markers = [...markers];
      }
    },
    drawElementLayer() {
      for (var l in this.mapSettings.map._layers) {
        if (this.dataObj.captureOtherMissingElement) {
          if (this.mapSettings.map._layers[l].options.color == this.parentComp.captureElements.colorArray[this.parentComp.captureElements.selectedElementIdx]) {
            this.mapSettings.map.removeLayer(this.mapSettings.map._layers[l]);
          }
        } else if (this.dataObj.captureFieldElements) {
          if (this.mapSettings.map._layers[l].options.color == this.dataObj.colorArray[this.parentComp.selectedCapturedElementIdx]) {
            this.mapSettings.map.removeLayer(this.mapSettings.map._layers[l]);
          }
        } else {
          if (this.mapSettings.map._layers[l].options.color == this.captureElementPolylineColor)
            this.mapSettings.map.removeLayer(this.mapSettings.map._layers[l]);
        }
      }

      const mrks = this.markers.filter(a => !a.isCenter && a.marker);
      //console.log(mrks);
      this.saveMarkersIntoParent(mrks);

      var plyCord = [];
      for (var i = 0; i < mrks.length; i++) {
        var subPlyCord = [];
        subPlyCord.push(mrks[i].position.lat);
        subPlyCord.push(mrks[i].position.lng);

        plyCord.push(subPlyCord);
      }

      const clr = this.dataObj.captureOtherMissingElement ?
        this.parentComp.captureElements.colorArray[this.parentComp.captureElements.selectedElementIdx]
        : this.dataObj.captureFieldElements ?
          this.dataObj.colorArray[this.parentComp.selectedCapturedElementIdx]
          : this.captureElementPolylineColor;

      let elementGeometryType = 0;
      if (this.dataObj.captureOtherMissingElement)
        elementGeometryType = this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType;
      if (this.dataObj.captureFieldElements)
        elementGeometryType = this.parentComp.capturedElements[this.parentComp.selectedCapturedElementIdx].elementType.geometryType;

      if (elementGeometryType == 1) {
        L.polyline(plyCord, {
          ...this.mapSettings.polyline,
          color: clr,
        }).addTo(this.mapSettings.map);
      } else if (elementGeometryType == 2) {
        L.polygon(plyCord, {
          weight: 3,
          color: clr,
        }).addTo(this.mapSettings.map);
      }
    },
    removeMarkerPopupHandler(event) {
      const btn = document.querySelector(".remove");

      this.markerIdx = this.markers.indexOf(this.markers.filter(a => !a.isCenter && a.marker).filter(a => a.marker.options.alt == event.target.options.alt)[0]);
      btn.addEventListener("click", this.removeMarker);
    },
    removeMarker() {
      this.mapSettings.map.removeLayer(this.markers[this.markerIdx].marker);

      this.markers.splice(this.markerIdx, 1);
      this.drawElementLayer();
    },
    addMarker(event) {
      if (this.dataObj.captureMissingJobcardElement) {
        if (this.markers.filter(a => !a.isCenter && a.marker).length == 1 && this.dataObj.elementType.geometryType == 0)
          return;
      }

      if (this.dataObj.captureOtherMissingElement) {
        if (this.markers.filter(a => !a.isCenter && a.marker).length == 1 && this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 0)
          return;
      }

      if (this.dataObj.captureFieldElements) {
        if (this.markers.filter(a => !a.isCenter && a.marker).length == 1 && this.dataObj.elementType.geometryType == 0)
          return;
      }

      this.captureElementMarkersCnt++;

      const buttonRemove =
        `<button type="button" class="remove">${this.$t('common.removeMarker')}</button>`;

      const position = {
        lat: event.latlng.lat,
        lng: event.latlng.lng
      };

      const marker = L.marker(position,
        {
          draggable: true,
          icon: L.icon({
            iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
            iconAnchor: [12, 41],
            popupAnchor: [12, -41]
          }), alt: this.dataObj.captureOtherMissingElement ? `marker__${this.parentComp.captureElements.selectedElementIdx.toString()}__${this.captureElementMarkersCnt.toString()}`
            : this.dataObj.captureFieldElements ? `marker__${this.dataObj.missingElementIndex.toString()}__${this.captureElementMarkersCnt.toString()}`
              : this.captureElementMarkersCnt.toString()
        }
      ).addTo(this.mapSettings.map)
        .bindPopup(buttonRemove);

      marker.on('dragend', (event) => {

        //console.log(this.markers);

        this.markerIdx = -1;
        if (this.dataObj.captureOtherMissingElement || this.dataObj.captureFieldElements) {
          this.markerIdx = this.markers.indexOf(this.markers.filter(a => !a.isCenter).filter(a => a.marker?.options?.alt == event.target.options.alt)[0]);
        } else {
          this.markerIdx = this.markers.indexOf(this.markers.filter(a => !a.isCenter).filter(a => a.marker?.options?.alt == event.target.options.alt)[0]);
        }

        this.markers[this.markerIdx].position.lat = event.target._latlng.lat;
        this.markers[this.markerIdx].position.lng = event.target._latlng.lng;

        if (this.dataObj.captureMissingJobcardElement) {
          if (this.dataObj.elementType.geometryType == 1 || this.dataObj.elementType.geometryType == 2)
            this.drawElementLayer();
        }

        if (this.dataObj.captureOtherMissingElement) {
          if (this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 1 || this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 2)
            this.drawElementLayer();
        }

        if (this.dataObj.captureFieldElements) {
          if (this.dataObj.elementType.geometryType == 1 || this.dataObj.elementType.geometryType == 2)
            this.drawElementLayer();
        }
      });

      this.markers.push({ position, marker });
      this.dataObj.markers.push({ position, marker });

      marker.on("popupopen", this.removeMarkerPopupHandler);

      if (this.dataObj.captureMissingJobcardElement) {
        if (this.dataObj.elementType.geometryType == 1 || this.dataObj.elementType.geometryType == 2)
          this.drawElementLayer();
      }

      if (this.dataObj.captureOtherMissingElement) {
        if (this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 1 || this.parentComp.captureElements.elements[this.parentComp.captureElements.selectedElementIdx].elementType.geometryType == 2)
          this.drawElementLayer();
      }

      if (this.dataObj.captureFieldElements) {
        if (this.dataObj.elementType.geometryType == 1 || this.dataObj.elementType.geometryType == 2)
          this.drawElementLayer();
      }
    },
    async loadSystemPolylines() {
      if (this.mapSettings.isRendering)
        return;

      this.mapSettings.isRendering = true;
      const bounds = this.mapSettings.map.getBounds();

      this.systemPolylines = this.filterPolylinesByBounds(this.allSystemPolylines, bounds);

      this.clearPolylines();

      while (this.mapSettings.isRendering) {
        for (let i = 0; i < (this.systemPolylines.length); i++) {
          let item = this.systemPolylines[i];

          await this.sleep(1);
          const polyline = L.polyline(
            item.path, {
            color: this.mapSettings.systemPolylineColor,
            ...this.mapSettings.polyline,
          }).addTo(this.mapSettings.map).bindTooltip(item.name);

          polyline['data'] = this.layers[0].geoJson.features[i];
        }
      }
    },
    isMobile() {
      var check = false;

      //const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      //const isTablet = /iPad|Android|Tablet/i.test(navigator.userAgent);

      const screenWidth = window.innerWidth;
      if (screenWidth <= 1380) {
        check = true;
      }

      //(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);

      this.deviceIsMobile = check;

      if (check) {
        navigator.geolocation.getCurrentPosition(this.successGetMobileLocation, this.errorGetMobileLocation);
      }
    },
    successGetMobileLocation(position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      this.currentMobileLocation = [];
      this.currentMobileLocation.push(latitude);
      this.currentMobileLocation.push(longitude);
    },
    errorGetMobileLocation(err) {
      this.currentMobileLocation = [];
      //console.log(err);
    },

    centerMap() {
      //center around point and zoom to have the both visible
      this.mapSettings.map.setZoom(this.mapSettings.zoom).panTo(this.currentMobileLocation);
    },

    offsetSliderChange(value) {
      if (value < 100)
        this.mapSettings.offset = 0; //All
      else
        this.mapSettings.offset = value / 100000;

      this.mapSettings.offsetChanged = true;

      this.saveToLocal('_map_load_around_center', value);

      this.onOffsetChanged();
    },
    polyLineWidthChanged(value) {
      if (!value)
        return;

      this.mapSettings.polyline.weight = value;
      this.saveToLocal('_map_polyline_weight', this.mapSettings.polyline.weight);
      this.loadPolylines();
    },
    lineWidthLabel(value) {
      return value + ' px';
    }
  },
}
